{
  "gameName": "Atlas-spel",
  "start": "Starten",
  "chooseTheme": "Kies een thema",
  "gameInstructionsTitle": "Speluitleg",
  "allThemes": "Grabbelton",
  "gameInstructions": [
    "Test je kennis over Nederland. Beantwoord 5 vragen over de leefomgeving en leer Nederland beter kennen.",
    "Klik op een provincie in de kaart om de vraag te beantwoorden. Is het antwoord juist, dan verdien je 200 punten. In totaal kun je dus 1000 punten verdienen.",
    "Per vraag krijg je 3 pogingen om het juiste antwoord te geven. Is het antwoord fout, dan halveren de punten die je voor de vraag kunt krijgen.",
    "Bij elke vraag is een hint beschikbaar. Klik op het i-tje. Let op: een hint kost 25 punten.",
    "Je kunt zo vaak meedoen als je wilt."
  ],
  "startText": "Hoe goed ken jij Nederland? Speel het Atlas-spel en toets jouw kennis.",
  "errors": {
    "serverError": "Server fout",
    "questionsError": "Het lukt niet om de vragen van de server op te halen.",
    "mapConfigError": "Het lukt niet om de kaart van de server op te halen.",
    "tryLater": "Probeer later de webpagina opnieuw te laden.",
    "noQuestionsFound": "Geen vragen gevonden.",
    "questionLayerError": "Het lukt niet om het uitklapmenu met mogelijke antwoorden van de server op te halen"
  },
  "stop": "Stoppen",
  "hint": "Hint",
  "hintHeader": "Hint",
  "nextQuestion": "Volgende vraag",
  "wrongAnswerFeedback": "Helaas! Probeer het nog een keer",
  "wrongAnswerAndOverFeedback": "Helaas! Je krijgt 0 punten voor deze vraag",
  "showOnMap": "Bekijk kaart",
  "hideMap": "Verberg kaart",
  "attempt": "Poging",
  "correctAnswerIs": "Het juiste antwoord is:",
  "correct": "Goed!",
  "pointsEarned": "Je krijgt %% punten voor deze vraag",
  "pointsEarnedShort": "+%% pt",
  "answerExplanation": "Uitleg antwoord",
  "viewScore": "Bekijk je score",
  "legend": "Legenda",
  "scoreHeader": "Jouw eindscore",
  "scoreHeaderIfHasTheme": "Jouw eindscore voor: ",
  "points": "punten",
  "scoreStatus": "%% van %% punten",
  "playAgain": "Speel nog een spel",
  "maxScoreVerdict": "Fantastisch gedaan!",
  "highScoreVerdict": "Goed gedaan!",
  "mediumScoreVerdict": "Uitstekend gedaan!",
  "lowScoreVerdict": "Volgende keer beter!",
  "shareOrPlayAgain": "Deel je score of speel nog een keer",
  "shareScore": "Deel mijn score",
  "shareText": "Ik heb score %% behaald met het Atlas-spel. Verbeter jij mijn score?",
  "playAnotherTheme": "Speel een ander thema",
  "attemptsPerQuestion": "Pogingen per vraag",
  "more": "Meer",
  "copyToClipboard": "Kopieer naar klembord",
  "expandOrCollapseAnswer": "Toon of verberg antwoord voor vraag: ",
  "clickOnMapOrSelectAnswer": "Klik op de kaart of kies een antwoord ..."
}
